export { default } from './List'



// WEBPACK FOOTER //
// ./scripts/components/layout/list/index.js